import { computed, onMounted, onUnmounted, ref } from 'vue'

const online = ref(typeof navigator === 'undefined' ? true : navigator.onLine)
let listening = false
let mountedCount = 0

function apply(next: boolean): void {
  online.value = next
}

function onBrowserOnline(): void {
  apply(true)
}

function onBrowserOffline(): void {
  apply(false)
}

function ensureListening(): void {
  if (listening || typeof window === 'undefined') return
  listening = true
  apply(navigator.onLine)
  window.addEventListener('online', onBrowserOnline)
  window.addEventListener('offline', onBrowserOffline)
}

function releaseListening(): void {
  if (!listening || typeof window === 'undefined') return
  if (mountedCount > 0) return
  listening = false
  window.removeEventListener('online', onBrowserOnline)
  window.removeEventListener('offline', onBrowserOffline)
}

/** Browser online/offline (not API health). */
export function useNetworkStatus() {
  onMounted(() => {
    mountedCount += 1
    ensureListening()
  })

  onUnmounted(() => {
    mountedCount = Math.max(0, mountedCount - 1)
    releaseListening()
  })

  // Eager listen for stores / API helpers that call before a Vue mount.
  ensureListening()

  return {
    online: computed(() => online.value),
    offline: computed(() => !online.value),
  }
}

export function isDeviceOnline(): boolean {
  ensureListening()
  return online.value
}
